import { render, staticRenderFns } from "./ChartStyleSwitcher.global.vue?vue&type=template&id=35370fc4&scoped=true&lang=pug&"
import script from "./ChartStyleSwitcher.global.vue?vue&type=script&lang=ts&"
export * from "./ChartStyleSwitcher.global.vue?vue&type=script&lang=ts&"
import style0 from "./ChartStyleSwitcher.global.vue?vue&type=style&index=0&id=35370fc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35370fc4",
  null
  
)

export default component.exports